import { http } from '../client';
import { c3SearchDataType, c3SearchDataTypeNew } from '../../pages/c3-page/add/types';
import { from, Observable } from 'rxjs';
import { pickResult } from '@api/utils';
import { paramterize } from '@api/utils';


// Mock data for C3 relations
const mockC3Data: c3SearchDataType[] = [
  {
                "content_status": "Released",
                "content_title": "Crossings: John Woo",
                "content_type": "Movie",
                "content_vtr_id": "5c6bb07ff53f23d011ab390ad51926d103edce1f79a637b8dc7e6035",
                "datasource_id": 1001,
                "genres": "Documentary",
                "ingestion_method": "",
                "language": "English",
                "modified_at": null,
                "modified_by": null,
                "person_name": "David Chute",
                "person_vtr_id": "b7611f2c7da9657a97841f52f1e656d0045223d12a4b4312e2c4cc35",
                "release_year": "2004",
                "role": "acting",
                "status": "Released",
                "sub_role": null,
                "vtr_id": "8e1736a641abd7ba4d447e801cab79553fd138d220d0d5807a046c87"
            },
            {
                "content_status": "Released",
                "content_title": "Crossings: John Woo",
                "content_type": "Movie",
                "content_vtr_id": "5c6bb07ff53f23d011ab390ad51926d103edce1f79a637b8dc7e6035",
                "datasource_id": 1001,
                "genres": "Documentary",
                "ingestion_method": "",
                "language": "English",
                "modified_at": null,
                "modified_by": null,
                "person_name": "Terence Chang",
                "person_vtr_id": "c86f1c3ab16130d35a1dc12cd1eed6712163ac0d7b12fd4cf867ad92",
                "release_year": "2004",
                "role": "acting",
                "status": "Released",
                "sub_role": null,
                "vtr_id": "98eba753f86a73ecf191ebc5993f0170dc390b5657cdd1030a1f937e"
            },
            {
                "content_status": "Released",
                "content_title": "Johnny Suede",
                "content_type": "Movie",
                "content_vtr_id": "266f26999a905736662398ec8efca605b2afa5a383cb864899928959",
                "datasource_id": 1001,
                "genres": "Comedy,Romance",
                "ingestion_method": "",
                "language": "English",
                "modified_at": null,
                "modified_by": null,
                "person_name": "Ralph Marrero",
                "person_vtr_id": "89e84aa05ed5d4ae9c8e157c1aa9b799205090ce887a071d98656eb8",
                "release_year": "1991",
                "role": "acting",
                "status": "Released",
                "sub_role": null,
                "vtr_id": "3126d1660d7a9b868e4ded579e9c8ea3754e44e2b76faa10106d3ceb"
            },
            {
                "content_status": "Released",
                "content_title": "Crossings: John Woo",
                "content_type": "Movie",
                "content_vtr_id": "5c6bb07ff53f23d011ab390ad51926d103edce1f79a637b8dc7e6035",
                "datasource_id": 1001,
                "genres": "Documentary",
                "ingestion_method": "",
                "language": "English",
                "modified_at": null,
                "modified_by": null,
                "person_name": "Annie Woo",
                "person_vtr_id": "df58984a4c6ad9d2f314a14dd0d22dffcce6b608f74251c7a2f7c821",
                "release_year": "2004",
                "role": "acting",
                "status": "Released",
                "sub_role": null,
                "vtr_id": "51feaecd4282a881ffe3ef03540d5ef0260cf3a2c479449efc369632"
            },
            {
                "content_status": "Released",
                "content_title": "Crossings: John Woo",
                "content_type": "Movie",
                "content_vtr_id": "5c6bb07ff53f23d011ab390ad51926d103edce1f79a637b8dc7e6035",
                "datasource_id": 1001,
                "genres": "Documentary",
                "ingestion_method": "",
                "language": "English",
                "modified_at": null,
                "modified_by": null,
                "person_name": "Arthur Anderson",
                "person_vtr_id": "904d9f907a6864b891a74ccdc2b39a7d367fa5cfe9aed8cc7908ad95",
                "release_year": "2004",
                "role": "acting",
                "status": "Released",
                "sub_role": null,
                "vtr_id": "af98e3f7256bd35db3fd48ac6eb477f7a8bb0ad5c436e0db8df1b99e"
            },
            {
                "content_status": "Released",
                "content_title": "Crossings: John Woo",
                "content_type": "Movie",
                "content_vtr_id": "5c6bb07ff53f23d011ab390ad51926d103edce1f79a637b8dc7e6035",
                "datasource_id": 1001,
                "genres": "Documentary",
                "ingestion_method": "",
                "language": "English",
                "modified_at": null,
                "modified_by": null,
                "person_name": "Kei Sek",
                "person_vtr_id": "30994cf866b1305f2a0d4a31a1f27477dace611cbc6008f80b940e76",
                "release_year": "2004",
                "role": "acting",
                "status": "Released",
                "sub_role": null,
                "vtr_id": "20728c4deb9543074fdb9035befbc82158aa89adfcc4ae94fb6500ff"
            },
            {
                "content_status": "Released",
                "content_title": "Crossings: John Woo",
                "content_type": "Movie",
                "content_vtr_id": "5c6bb07ff53f23d011ab390ad51926d103edce1f79a637b8dc7e6035",
                "datasource_id": 1001,
                "genres": "Documentary",
                "ingestion_method": "",
                "language": "English",
                "modified_at": null,
                "modified_by": null,
                "person_name": "Elliot Ngok Wah",
                "person_vtr_id": "6c7fd3357abfd147a6c3292423c051d2f9b6f630716e57f47b845894",
                "release_year": "2004",
                "role": "acting",
                "status": "Released",
                "sub_role": null,
                "vtr_id": "be2607a97fc16d80b5cd002b04ed93cd53858f29d3c4dad7e2fde73d"
            },
            {
                "content_status": "Released",
                "content_title": "Crossings: John Woo",
                "content_type": "Movie",
                "content_vtr_id": "5c6bb07ff53f23d011ab390ad51926d103edce1f79a637b8dc7e6035",
                "datasource_id": 1001,
                "genres": "Documentary",
                "ingestion_method": "",
                "language": "English",
                "modified_at": null,
                "modified_by": null,
                "person_name": "Remesh K. Panicker",
                "person_vtr_id": "96b62b4a229a696b67ab262abddc2f1fc05cbf073530489485d0bd41",
                "release_year": "2004",
                "role": "acting",
                "status": "Released",
                "sub_role": null,
                "vtr_id": "a0d12d762a18662b57e7bbf6418525db7ecef25be513a34b7521a7d9"
            },
            {
                "content_status": "Released",
                "content_title": "Crossings: John Woo",
                "content_type": "Movie",
                "content_vtr_id": "5c6bb07ff53f23d011ab390ad51926d103edce1f79a637b8dc7e6035",
                "datasource_id": 1001,
                "genres": "Documentary",
                "ingestion_method": "",
                "language": "English",
                "modified_at": null,
                "modified_by": null,
                "person_name": "Tsui Hark",
                "person_vtr_id": "8d215224799a93b861b8f50ff21b24227afd63014a3e7565d7f33449",
                "release_year": "2004",
                "role": "acting",
                "status": "Released",
                "sub_role": null,
                "vtr_id": "a8e56e7866c956de467fef58bb92624ecc5ad3b0a32ac8ead5278bb1"
            },
            {
                "content_status": "Released",
                "content_title": "Crossings: John Woo",
                "content_type": "Movie",
                "content_vtr_id": "5c6bb07ff53f23d011ab390ad51926d103edce1f79a637b8dc7e6035",
                "datasource_id": 1001,
                "genres": "Documentary",
                "ingestion_method": "",
                "language": "English",
                "modified_at": null,
                "modified_by": null,
                "person_name": "David Chiang Da-Wei",
                "person_vtr_id": "02877d8ed2e786ade940622062aa7d5f5b99c505e6eeaace1a9717b1",
                "release_year": "2004",
                "role": "acting",
                "status": "Released",
                "sub_role": null,
                "vtr_id": "528254f6df4718d1d4474f4a0763aeffd23893b0baf4e46ed91a69d6"
            }
];
// Mock data for C3 relations
const mockC3DataNew: c3SearchDataTypeNew[] = [{data:[
  {
    content_name: 'The Great Movie',
    content_vtr_id: 'C001',
    content_type: 'Movie',
    content_language: 'English',
    content_genre: 'Action, Drama',
    content_status: 'Released',
    release_year: '2023',
    person_name: 'John Doe',
    person_vtr_id: 'P001',
    role: 'Actor',
    sub_role: 'Lead Actor',
    source: 'IMDB',
    ingestion_method: 'API',
    modified_at: '2023-12-01T10:00:00Z',
    modified_by: 'admin@example.com',
    content_person_relation_id: 'CPR001',
  },
  {
    content_name: 'Amazing TV Series',
    content_vtr_id: 'C002',
    content_type: 'TV Series',
    content_language: 'English',
    content_genre: 'Comedy, Romance',
    content_status: 'In Production',
    release_year: '2023',
    person_name: 'Jane Smith',
    person_vtr_id: 'P002',
    role: 'Director',
    sub_role: 'Director',
    source: 'Manual Entry',
    ingestion_method: 'Manual',
    modified_at: '2023-11-15T14:30:00Z',
    modified_by: 'user@example.com',
    content_person_relation_id: 'CPR002',
  },
  {
    content_name: 'Epic Documentary',
    content_vtr_id: 'C003',
    content_type: 'Documentary',
    content_language: 'Spanish',
    content_genre: 'Documentary, History',
    content_status: 'Post Production',
    release_year: '2024',
    person_name: 'Mike Johnson',
    person_vtr_id: 'P003',
    role: 'Producer',
    sub_role: 'Executive Producer',
    source: 'TMDb',
    ingestion_method: 'API',
    modified_at: '2023-12-10T09:15:00Z',
    modified_by: 'admin@example.com',
    content_person_relation_id: 'CPR003',
  },
  {
    content_name: 'Sci-Fi Blockbuster',
    content_vtr_id: 'C004',
    content_type: 'Movie',
    content_language: 'English',
    content_genre: 'Sci-Fi, Action',
    content_status: 'Released',
    release_year: '2023',
    person_name: 'Sarah Wilson',
    person_vtr_id: 'P004',
    role: 'Writer',
    sub_role: 'Screenwriter',
    source: 'IMDB',
    ingestion_method: 'API',
    modified_at: '2023-10-20T16:45:00Z',
    modified_by: 'editor@example.com',
    content_person_relation_id: 'CPR004',
  },
  {
    content_name: 'Romantic Comedy',
    content_vtr_id: 'C005',
    content_type: 'Movie',
    content_language: 'French',
    content_genre: 'Romance, Comedy',
    content_status: 'Released',
    release_year: '2022',
    person_name: 'Pierre Dubois',
    person_vtr_id: 'P005',
    role: 'Actor',
    sub_role: 'Supporting Actor',
    source: 'Manual Entry',
    ingestion_method: 'Manual',
    modified_at: '2023-09-05T11:20:00Z',
    modified_by: 'user@example.com',
    content_person_relation_id: 'CPR005',
  },
],
count:5,
page_size:1}]

export interface C3SearchParams {
  page?: number;
  page_size?: number;
  sortBy?: Array<{ id: string; desc: boolean }>;
  filters?: Array<{ id: string; value: Record<string, any> }>;
}

export interface C3SearchResponse {
  data: c3SearchDataType[];
  pageCount: number;
  rowCount: number;
}
interface C3SearchResponseNew {
  count: number;
  data: c3SearchDataType[];
  page_size: number;
}

// Observable wrapper
export const searchC3PageRelations = (
  payload: C3SearchParams
): Observable<C3SearchResponseNew> => {
//  return from(mocknewSearch(payload));
 const {page_size,page,sortBy,filters}=payload

  const newFilters = filters; //updateFiltersForLinkedOperator(filters);
  const resolveId = (id: string) => {
    return { buyers: 'buyer', sellers: 'seller', contents: 'content', to_air_on: 'to_air_on', updated_at_filter: 'updated_at' }[id] || id;
  };
  const filtersMap: Record<string, string> = newFilters.reduce(
    (map, f) =>
      Object.assign(map, {
        [resolveId(f.id)]: Object.entries(f.value)
          .map(([op, v]) => (
            op === '$bw' ? `$gte|||${v[0]};$lte|||${v[1]}` : `${op}|||${v.trim()}`)
            )
          .join(';'),
      }),
    {}
  );

  return http.get(`content-person-relation/searches`,{
         params: paramterize({
           page,
           page_size,
          ...filtersMap,
         }),
       }).pipe(pickResult());
 
};

export function getC3RelationById(vtr_relation_id: string) {
  return http.get(`/content-person-relation/${vtr_relation_id}`).pipe(pickResult());
}

export const createC3Relation = (c3Payload: any) => {
  // Mock implementation
return http.post(`/content-person-relation`, c3Payload).pipe(pickResult());
};

export const updateC3Relation = (id: string, data: any) => {
    return http.put(`/content-person-relation/${id}`, data).pipe(pickResult());
};

export const deleteC3Relation = (person_company_rel_id: any) => {
    return http.delete(`/content-person-relation/${person_company_rel_id}`).pipe(pickResult());
};
